<template>
  <div class="text-center">
    <img class="img-fluid mr-2" :class='{ spinner: isLoading}' src="/beta/static/logo-64x64.png" style="width: 32px; height: 32px" alt="womia">
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: { isLoading: { type: Boolean, default: false } }
}
</script>



// WEBPACK FOOTER //
// src/components/Spinner.vue